<template>
  <v-app> 
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      :fixed = "fixed"
      app
      >
      <v-toolbar dense  class="transparent">
        <v-list class="pa-0">
          <v-list-tile avatar >
            <v-list-tile :to="{name:'PerfilUsuario'}" @click.capture="routeTo({name:'PerfilUsuario'})">
              <v-list-tile-avatar style="cursor: pointer;" >
                <img lt="image" class="img-circle" :src='fotoPerfil' width="40px">
              </v-list-tile-avatar>
            </v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>{{$store.getters.getUserData.username}}</v-list-tile-title>
            </v-list-tile-content>
            <v-menu inset class="text-xs-center">
              <v-list-tile-action slot="activator">
                <v-icon>more_vert</v-icon>
              </v-list-tile-action>
              <v-list>
                <v-list-tile @click="askForLogOut()">
                  <v-list-tile-action >
                    <v-icon color="teal darken-2">no_encryption</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{$t("view.home.cerrarSesion.text")}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile  :to="{name:'PerfilUsuario'}" @click.capture="routeTo({name:'PerfilUsuario'})" >
                  <v-list-tile-action >
                    <v-icon color="green darken-2">person_pin</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{$t("view.home.perfilUsuario.text")}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list dense>
        <template v-for="item in items" v-show="item.permission === undefined || $userPermission.hasPermission(item.permission)">          
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
          </v-layout>
          <v-divider
            v-else-if="item.divider"
            :key="item.heading"
            dark
            class="my-3"
          ></v-divider>
          <v-list-group 
          v-show="item.permission === undefined || $userPermission.hasPermission(item.permission)"
          v-else-if="item.children" v-model="item.model" :key="item.text" 
            :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
              <v-list-tile 
              v-for="(child, i) in item.children"
              :key="i"
              v-show="child.permission === undefined || $userPermission.hasPermission(child.permission)"
              :to="child.action"
              @click.capture="routeTo(child.action)"
              :class="(child.action.name == $route.name ? 'v-list__tile--active primary--text submenu--active':'')"
              >
              
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              
            </v-list-tile>
          </v-list-group>
          <v-list-tile 
          v-show="item.permission === undefined || $userPermission.hasPermission(item.permission)" 
          v-else :key="item.text" 
          :class="(item.action.name === $route.name ? 'v-list__tile--active primary--text submenu--active':'')" 
          :to="item.action"
          @click.capture="routeTo(item.action)">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar dense app :fixed = "fixed" :clipped-left="clipped"  dark color="primary">
      <v-toolbar-title class="hidden-sm-and-down" style="width: 380px" v-text="title" >
      </v-toolbar-title>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn class="hidden-sm-and-down" icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'apps' : 'apps'"></v-icon>
      </v-btn>
      <v-btn class="hidden-sm-and-down" icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>
      
      <v-flex xs10 offset-xs1>
        <v-toolbar-title dense v-text="system"></v-toolbar-title>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn icon @click="askForLogOut()">
        <v-icon>no_encryption</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content id="container"  >
      <v-toolbar dense primary-title>
        <v-toolbar-title>{{view.titleHeading}}</v-toolbar-title>
      </v-toolbar>
      <breadcrumbs class="py-2 subheading"/>
      <v-fab-transition>
        <v-btn @click="goToTop()" color="primary" v-show="showButonTop"
          key="keyboard_arrow_up" icon small dark fab fixed bottom right>
          <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>
      </v-fab-transition>
      <router-view v-scroll="onScroll"  ref="childView" ></router-view>
    </v-content>
    <v-footer app :fixed = "fixed" :inset="clipped">
      <span>{{$t("view.home.footer.sistema")}}</span>
      <v-spacer/>
      <strong>&copy;</strong> {{$t("view.home.footer.copyRight")}}
    </v-footer>
    <vue-toastr ref="toastr"></vue-toastr>
    <v-snackbar v-model="snackbar.show" v-bind="snackbar" style="z-index: 2200;" >
      {{snackbar.message }}
      <v-btn icon dark flat @click="snackbar.show = false" >
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-title align-center justify-center>
          {{$t('view.global.common.loading')}}
        </v-card-title>
        <v-card-text dark>
          <v-layout align-center justify-center row >
            <semipolar-spinner
              :animation-duration="2000"
              :size="75"
              color="white"
            />
          </v-layout>
          <!-- <v-progress-circular
            :size="100"
            color="primary"
            :rotate="90"
            indeterminate >
            <v-progress-circular
              :size="70"
              color="secondary"
              indeterminate
              :rotate="50"
            >
              <v-progress-circular
                color="accent"
                indeterminate
              ></v-progress-circular>
            </v-progress-circular>
          </v-progress-circular> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Auth from '@/services/auth';
import User from '@/services/api/users';
import BitacoraAPI from "@/services/bitacoras/bitacora";
import * as actions from '@/constants/mutation-names';
import Toastr from 'vue-toastr';
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import {appJQueryConfig} from '@/plugins/jquery/app-config';
import {getErrorsNetwork} from '@/helpers/http-response-handler';
import {scrollToForm} from '@/helpers/form-scroll-to';
import { SemipolarSpinner } from 'epic-spinners';


export default {
  name: 'Home',
  data() {
    return {
      view:{
        titleHeading:"Inicio"
      }
      , clipped: true
      , drawer: true
      , fixed: true
      , items: [
        { icon: 'home', text: this.$t("view.menu.inicio.text") , action:{name:"Feeds"}, permission: 'ROLE_ACCESO_AFC'}
        , {
          icon: 'mdi mdi-radar'
          , 'icon-alt' : 'mdi mdi-radar'
          , text: this.$t("view.seguimientoControl.title")
          , permission: 'ROLE_ACCESO_BITACORA_ARCHIVOS,ROLE_ACCESO_PROCESOS'
          , model: false
          , children:[
            { icon: 'mdi mdi-buffer', text: this.$t("view.bitacoraArchivos.title"), action:{name:'BitacoraArchivo'}, permission:'ROLE_ACCESO_BITACORA_ARCHIVOS' }
            , {icon:'mdi mdi-bullseye-arrow', text:this.$t("view.seguimientoControl.scheduled.title"), action:{name:'SeguimientoControlScheduled'} , permission:'ROLE_ACCESO_PROCESOS'}
          ]
        }
        , { 
          icon: 'security'
          , 'icon-alt' : 'security'
          , text: this.$t("view.menu.seguridad.text") 
          , action:{name:"Usuario"}
          , permission: 'ROLE_ACCESO_SEGURIDAD'
          , model: false
          , children: [
            { icon: 'account_box', model: false, text: this.$t("view.menu.seguridad.sub.usuario.text"), action:{name:'Usuario'} }
            , { icon: 'people_outline', model: false, text: this.$t("view.menu.seguridad.sub.perfiles.text"), action:{name:'Perfil'} }
          ]
        },
        { 
          icon: 'work'
          , 'icon-alt' : 'work'
          , text: this.$t("view.menu.catalogosGenerales.text") 
          , permission: 'ROLE_ACCESO_CATALOGOS,ROLE_ACCESO_PARAMETROS,ROLE_ACCESO_COMERCIO'
          , model: false
          , children: [
            { icon: 'content_copy', text: this.$t("view.menu.catalogosGenerales.sub.plantillasCorreo.text"), action:{name:'PlantillaCorreo'}, permission:'ROLE_ACCESO_CATALOGOS' }
            , { icon: 'settings', text: this.$t("view.menu.catalogosGenerales.sub.parametros.text"), action:{name:'Parametros'}, permission: 'ROLE_ACCESO_PARAMETROS' }
            , { icon: 'store', text: this.$t("view.comercio.title"), action:{name:'Comercio'}, permission:'ROLE_ACCESO_COMERCIO'}
          ]
        },
        { 
          icon: 'history'
          , 'icon-alt' : 'history'
          , text: this.$t("view.menu.consultaBitacoras.text") 
          , permission: 'ROLE_ACCESO_BITACORA'
          , model: false
          , children: [
            { icon: 'mdi mdi-clock-fast', text: this.$t("view.menu.consultaBitacoras.sub.bitacora.text"), action:{name:'Bitacora'} }
            , { icon: 'mdi mdi-database-search', text: this.$t("view.menu.consultaBitacoras.sub.reportesAuditoria.text"), action:{name:'ReporteAuditoria'}, permission: 'ROLE_ACCESO_REPORTES_AUDITORIA' }
            , { icon: 'mdi mdi-email-search', text: this.$t("view.menu.consultaBitacoras.sub.monitorCorreos.text"), action:{name:'MonitorCorreos'}, permission: 'ROLE_ACCESO_BITACORA' }
            
          ]
        }
        
      ]
      , showButonTop: false
      , miniVariant: false
      , right: true
      , rightDrawer: false
      , title: this.$t('view.home.welcome.text')
      , system: this.$t("view.home.footer.sistema")
      , snackbar:{
        show: false
        , color: ''
        , mode : 'vertical'
        , right: true
        , top: true
        , timeout: 9000
        , text : ''
        , message : ''
      }
      , loading: false
    }
  },
  methods:{
    routeTo({name}){
      
      if(name==this.$route.name){
        this.$router.go(this.$router.currentRoute);
      }
      
      // this.regristrarBitacora(this.$router.currentRoute.meta.bitacora);
    }
    , async askForLogOut(){
      try{
        const response = await this.$swal({
          title: 'Cerrar Sesión',
          text: "Puede mejorar la seguridad cerrando el navegador una vez que ha salido del sistema",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0077BC',
          cancelButtonColor: '#e7eaec',
          confirmButtonText: 'Aceptar',
          reverseButtons: true
        });
        
        if(response.value){
          await this.logOut();
        }
      }catch(error){

      }
    }
    , async logOut() {
      try {
        this.$store.dispatch(actions.STOP_ID_SESSION_TIME_INTERVAL);
        const respuesta = await Auth.logOut();
        this.$store.dispatch(actions.AUTH_LOGOUT)
        this.$router.push("/auth");
      } catch (error) {
       throw error;
      }
    }
    , setPageTitleHeading(){
      if(this.$refs.childView===undefined) return ""
      this.view.titleHeading=this.$refs.childView.view.title || this.$t("view.home.footer.sistema");
    }
    , showToastr(code){
       this.$refs.toastr.s('Operación exitosa',code);
    }
    , showToastrError(message, code){
       this.$refs.toastr.e(message,code);
    }
    , toogleMiniNavigationBar(){

    }
    
    , appJQueryConfigMethod(){
      appJQueryConfig();
    }
    , onScroll (e) {
      this.showButonTop = (window.pageYOffset || document.documentElement.scrollTop)>0;
    }
    , goToTop(){
      this.$vuetify.goTo('#container', { "duration": 300, "offset": 0, "easing": "easeInOutCubic" });
    }
    
    
  }
  , computed:{
    getGroups(){
      if(!this.$store.getters.getUserData.grupos) return '';
      return this.$store.getters.getUserData.grupos.join('\n');
    }
    , titleHeading(){
      if(this.$refs.childView===undefined) return ""
      this.view.titleHeading=this.$refs.childView.view.title || this.$t("view.home.footer.sistema");
    }
    , fotoPerfil(){
      return this.$store.getters.getUserData.fotoPerfil;
    }
  }
  , mounted(){
    this.setPageTitleHeading();
    this.$refs.toastr.defaultTimeout = 5000; 
    const vm = this;
    this.$nextTick(
      vm.appJQueryConfigMethod
    );
    
  }
  , updated(){
    this.setPageTitleHeading();
  }
  , components: {
    'vue-toastr':Toastr
    , SemipolarSpinner
  }
  , created(){
    //Register Global Event Listener

    EventBus.$on(events.SESSION_TIME_FINISHED,data=>{ 
      this.$router.push({ name: 'SessionExpiredMessage', params: { username: data.username, nombre: data.nombre}})
    });

    EventBus.$on(events.MESSAGES,data=>{
      data.type = data.type === 'OK' ? 'success' : data.type;
      this.snackbar.color = data.type;
      this.snackbar.message = data.type === 'success' ? 'Operación exitosa' : data.message;
      this.snackbar.show = true;
    });


    EventBus.$on(events.LOADING,data=>{
      this.loading = data;
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.application .theme--light.v-icon, .theme--light .v-icon {
  color: inherit;
}

.submenu--active{
  /* border-left: 4px solid var(--primary);
  background: var(--primary-color); */
}

a{
  color:rgba(0,0,0,.87)
}


select.input-sm {
    /* height: 30px; */
    line-height: inherit !important;
}

.application.theme--light {
    background: #fafafa !important;
    background-image: initial;
    background-position-x: initial;
    background-position-y: initial;
    background-size: initial;
    background-repeat-x: initial;
    background-repeat-y: initial;
    background-attachment: initial;
    background-origin: initial;
    background-clip: initial;
    background-color: rgb(250, 250, 250) !important;
    color: rgba(0,0,0,.87) !important;
}

.v-toolbar--clipped {
    z-index: 5 !important;
}

</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue